<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button class="btn btn-secondary btn-fg custom-shadow-btn" @click="$router.push('/users/create')">
              <i class="fa fa-plus"></i>
              Agregar Usuario
            </button>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-12 text-center">
            <h6 class="text-muted">Usuarios Activos</h6>
          </div>
        </div>
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('usuarios', 'Usuarios', 'a4', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('usuarios', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('usuarios', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="180"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i>
                  </a>
                  <a v-if="canRol()" v-tooltip.top-center="'Gestionar Pefil'"
                    class="btn-warning btn-simple btn-link"
                    @click="handleRol(props.$index, props.row)"><i class="fa fa-tag"></i>
                  </a>
                  <a v-if="canPermissions()" v-tooltip.top-center="'Gestionar Permisos'"
                    class="btn-danger btn-simple btn-link"
                    @click="handlePermissions(props.$index, props.row)"><i class="fa fa-tags"></i>
                  </a>
                  <a v-if="canTemporary()" v-tooltip.top-center="'Contraseña Temporal'"
                    class="btn-info btn-simple btn-link"
                    @click="handleTemporary(props.$index, props.row)"><i class="fa fa-key"></i>
                  </a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)"><i
                    class="fa fa-edit"></i>
                  </a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i>
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row" style="padding-right: 13px; padding-left: 13px;">
    <el-dialog v-if="canCreate() || canUpdate()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody >
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Nombres: </b></h6>
                    {{rowData.first_name}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Apellidos: </b></h6>
                    {{rowData.last_name}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Nombre de Usuario: </b></h6>
                    {{rowData.username}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Correo: </b></h6>
                    {{rowData.email}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Supervisor de procesos: </b></h6>
                    {{rowData.process_label}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Contraseña Temporal: </b></h6>
                    {{rowData.temporary_label}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row" >
                    <h6><b>Perfil: </b></h6>
                    <span v-if="rowData.role_name">{{rowData.role_name[0]}}</span>
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6 class="custom-margin-h6-table"><b>Proyectos Asociados:</b></h6>
                    <template v-for="(demand, index) in rowData.demands">
                      <el-tag :key="demand.id"
                        size="small"
                        type="success"
                        :closable="false"
                        :close-transition="false">
                          {{demand.name}}
                      </el-tag>
                      <br :key="index+'Index'" v-if="(((index+1) % 4) == 0)"/>
                    </template>
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6 class="custom-margin-h6-table"><b>Permisos Asociados:</b></h6>
                    <template v-for="(permission, index) in rowData.all_permissions">
                      <el-tag :key="permission.id"
                        size="small"
                        type="success"
                        :closable="false"
                        :close-transition="false">
                          {{permission.name}}
                      </el-tag>
                      <br :key="index+'Index'" v-if="(((index+1) % 4) == 0)"/>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
            <div class="card-footer footer-date-at" v-if="rowData">
              <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
            </div>
        </div>
    </el-dialog>
    <el-dialog v-if="canPermissions()"
      :title="title"
      :visible.sync="modals.permissions">
      <span>A continuación seleccione los permisos a asociar con el usuario:</span><br><br>
      <el-select multiple class="select-primary select_modules"
        v-model="userForm.permissions"
        filterable placeholder="Seleccione uno o varios permisos">
        <el-option v-for="optionp in permissions"
                    class="select-primary"
                    :value="optionp.id"
                    :label="optionp.name"
                    :key="optionp.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('permissions')">Cancelar</button>&nbsp;
        <button class="btn btn-success" @click="addOrDeletePermission()">Confirmar</button>
      </span>
    </el-dialog>
    <el-dialog v-if="canRol()"
      :title="title"
      :visible.sync="modals.roles">
      <span>A continuación seleccione el perfil al cual pertenece este usuario:</span><br><br>
      <el-select class="select-primary select_modules"
        v-model="userForm.role_id"
        filterable placeholder="Seleccione un perfil">
        <el-option v-for="optiona in roles"
                    class="select-primary"
                    :value="optiona.id"
                    :label="optiona.name"
                    :key="optiona.name">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('roles')">Cancelar</button>&nbsp;
        <button class="btn btn-success" @click="changeRol()">Confirmar</button>
      </span>
    </el-dialog>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import table from './userTable'
  import moment from 'moment';

  export default {
    data () {
      return {
        userForm: {
          first_name: null,
          last_name: null,
          username: null,
          email: null,
          temporary_password: null,
          role_id: null,
          department_id: null,
          permissions: null,
        },
        modals: {
          permissions: false,
          roles: false,
        },
        permissions: null,
        roles: null,
        tableColumns: table,
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods: {
      handleView (index, row) {
        this.title = 'Usuario '+row.first_name+' '+row.last_name
        this.rowData = Object.assign({}, row)
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.modals['read'] = true
      },
      handleEdit (index, row) {
        this.userForm = Object.assign({}, row)
        this.assignFieldIds(row)
        localStorage.setItem( 'userEdit', JSON.stringify(this.userForm) )
        this.$router.push({ name: 'Editar Usuario' });
      },
      handleDelete (index, row) {
        this.assignFieldIds(row)
        showSwalAlert('Usuario', 'delete', true, null, 'usuario: '+row.first_name+' '+row.last_name).then((result) => {
          if (result.value) this.deleteUser()
        })
      },
      handleRol (index, row) {
        this.title = 'Gestionar role de '+row.first_name+' '+row.last_name
        this.userForm = Object.assign({}, row)
        this.userForm.route = 'users'
        this.assignFieldIds(row)
        this.modals['roles'] = true
      },
      handlePermissions (index, row) {
        this.title = 'Gestionar Permisos de '+row.first_name+' '+row.last_name
        this.assignFieldIds(row)
        this.openModal('permissions')
      },
      handleTemporary (index, row) {
        this.assignFieldIds(row)
        showSwalAlert('Usuario', 'temporary', true, null, 'usuario: '+row.first_name+' '+row.last_name).then((result) => {
          if (result.value) this.temporaryUser()
        })
        this.openModal('temporary')
      },
      temporaryUser(){
        this.$emit('cotentLoading', true)
        this.userForm.route = 'users/temporary'
        this.updateMaster(this.userForm)
          .then((response) => this.modifyTable(4, this.userForm.id, response, null, 'nc-key-25'))
          .catch((error) => this.showMessageErrors(error))
      },
      deleteUser(){
        this.$emit('cotentLoading', true)
        this.userForm.route = 'users'
        this.destroyMaster(this.userForm)
          .then((response) => this.modifyTable(2, this.userForm.id, response))
          .catch((error) => this.showMessageErrors(error))
      },
      addOrDeletePermission(){
        this.$emit('cotentLoading', true)
        this.userForm.route = 'users/permissions'
        this.saveMaster(this.userForm)
          .then((response) => this.modifyTable(3, this.userForm.id, response, 'permissions'))
          .catch((error) => this.showMessageErrors(error))
      },
      changeRol(){
        this.$emit('cotentLoading', true)
        this.userForm.route = 'users/rol/'+this.userForm.role_id
        this.saveMaster(this.userForm)
          .then((response) => this.modifyTable(3, this.userForm.id, response, 'roles'))
          .catch((error) => this.showMessageErrors(error))
      },
      assignFieldIds(row){
        this.userForm = Object.assign({}, row)
        this.userForm.demands = row.demands_ids
        this.userForm.permissions = row.permissions_ids
      }
    },
    created(){
      this.$emit('cotentLoading', true)
      if(this.canIndex()){
        this.getMasters('users').then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['name', 'username', 'email', 'role_name'])
          this.$emit('cotentLoading')
        }).catch((error) => this.showMessageErrors(error))
        this.getMasters('roles/index').then((response) => this.roles = response.data.data).catch((error) => this.showMessageErrors(error))
        this.getMasters('permissions/index').then((response) => this.permissions = response.data.data).catch((error) => this.showMessageErrors(error))
      }
    },
  }
</script>
<style>
</style>
